var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"semaforo-verde"},[_c('div',{staticClass:"check"})])
}]

export { render, staticRenderFns }